// import React, { useEffect, useState } from "react";
// import {
//     Table, Button, Input, Space, Tag, Modal, Typography, message,
//     Form, Select, Card, Row, Col, Statistic, Tooltip, Divider
// } from "antd";
// import {
//     SearchOutlined, ReloadOutlined, PlusOutlined, CopyOutlined,
//     QrcodeOutlined, LinkOutlined, CalendarOutlined, TeamOutlined,
//     DownloadOutlined, WhatsAppOutlined, ShareAltOutlined
// } from "@ant-design/icons";
// import { QRCodeCanvas } from "qrcode.react";
// import AdminLayout from "./Drawer";

// const { Text, Title } = Typography;
// const { Option } = Select;

// const ReferralCodeManagement = () => {
//     const [loading, setLoading] = useState(false);
//     const [events, setEvents] = useState([]);
//     const [referralCodes, setReferralCodes] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [searchText, setSearchText] = useState("");
//     const [createModalOpen, setCreateModalOpen] = useState(false);
//     const [detailsModalOpen, setDetailsModalOpen] = useState(false);
//     const [selectedReferral, setSelectedReferral] = useState(null);
//     const [form] = Form.useForm();

//     useEffect(() => {
//         fetchEvents();
//         fetchReferralCodes();
//     }, []);

//     useEffect(() => {
//         setFilteredData(referralCodes);
//     }, [referralCodes]);

//     const fetchEvents = async () => {
//         try {
//             const response = await fetch("/api/get/events", {
//                 method: "GET",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Accept: "application/json",
//                 },
//             });

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const data = await response.json();
//             if (data.status === "success") {
//                 setEvents(data.data);
//             }
//         } catch (error) {
//             console.error("Fetch error:", error.message);
//             message.error("Failed to fetch events");
//         }
//     };

//     const fetchReferralCodes = async () => {
//         setLoading(true);
//         try {
//             const response = await fetch("/api/referral/get-all", {
//                 method: "GET",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Accept: "application/json",
//                 },
//             });

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const data = await response.json();
//             if (data.status === "success") {
//                 setReferralCodes(data.data);
//             }
//         } catch (error) {
//             console.error("Error fetching referral codes:", error);
//             message.error("Failed to fetch referral codes");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const generateReferralCode = (eventCode, gateNumber) => {
//         const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // Removed ambiguous characters
//         let code = 'R';
//         for (let i = 0; i < 5; i++) {
//             code += chars.charAt(Math.floor(Math.random() * chars.length));
//         }
//         return code;
//     };

//     // const generateReferralCode = (eventCode, gateNumber) => {
//     //     const timestamp = Date.now().toString(36).toUpperCase();
//     //     const random = Math.random().toString(36).substring(2, 6).toUpperCase();
//     //     return `G${gateNumber}${timestamp}${random}`;
//     // };

//     const generateHexaCode = () => {
//         const chars = '0123456789ABCDEF';
//         let hexaCode = 'R';
//         for (let i = 0; i < 7; i++) {
//             hexaCode += chars[Math.floor(Math.random() * chars.length)];
//         }
//         return hexaCode;
//     };

//     const handleCreateReferral = async (values) => {
//         try {
//             const selectedEvent = events.find(e => e._id === values.eventId);
//             const referralCode = generateReferralCode(selectedEvent.code, values.gateNumber);
//             const hexaCode = generateHexaCode();
//             const referralLink = `${window.location.origin}/registration/2025/${hexaCode}`;

//             const payload = {
//                 eventId: values.eventId,
//                 gateNumber: values.gateNumber,
//                 referralCode: referralCode,
//                 hexaCode: hexaCode,
//                 referralLink: referralLink,
//                 createdBy: "Admin",
//                 maxUses: values.maxUses || null,
//                 expiryDate: values.expiryDate || null,
//             };

//             const response = await fetch("/api/referral/create", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Accept: "application/json",
//                 },
//                 body: JSON.stringify(payload),
//             });

//             const data = await response.json();

//             if (response.ok) {
//                 message.success("Referral code created successfully!");
//                 form.resetFields();
//                 setCreateModalOpen(false);
//                 fetchReferralCodes();

//                 // Show the created referral details
//                 setSelectedReferral({
//                     ...payload,
//                     _id: data.data._id,
//                     usageCount: 0,
//                     createdAt: new Date().toISOString(),
//                     eventName: selectedEvent.eventName,
//                 });
//                 setDetailsModalOpen(true);
//             } else {
//                 message.error(data.message || "Failed to create referral code");
//             }
//         } catch (error) {
//             console.error("Error creating referral:", error);
//             message.error("An error occurred while creating referral code");
//         }
//     };

//     // Fixed copy link function with better error handling
//     const handleCopyLink = async (link) => {
//         try {
//             if (!link) {
//                 message.error("No link available to copy");
//                 return;
//             }

//             // Try modern clipboard API first
//             if (navigator.clipboard && navigator.clipboard.writeText) {
//                 await navigator.clipboard.writeText(link);
//                 message.success("Referral link copied to clipboard!");
//             } else {
//                 // Fallback method for older browsers
//                 const textArea = document.createElement("textarea");
//                 textArea.value = link;
//                 textArea.style.position = "fixed";
//                 textArea.style.left = "-999999px";
//                 textArea.style.top = "-999999px";
//                 document.body.appendChild(textArea);
//                 textArea.focus();
//                 textArea.select();

//                 try {
//                     const successful = document.execCommand('copy');
//                     if (successful) {
//                         message.success("Referral link copied to clipboard!");
//                     } else {
//                         message.error("Failed to copy link");
//                     }
//                 } catch (err) {
//                     console.error('Fallback copy failed:', err);
//                     message.error("Failed to copy link");
//                 }

//                 document.body.removeChild(textArea);
//             }
//         } catch (error) {
//             console.error("Error copying to clipboard:", error);
//             message.error("Failed to copy link. Please copy manually.");
//         }
//     };

//     // Fixed copy code function
//     const handleCopyCode = async (code) => {
//         try {
//             if (!code) {
//                 message.error("No code available to copy");
//                 return;
//             }

//             if (navigator.clipboard && navigator.clipboard.writeText) {
//                 await navigator.clipboard.writeText(code);
//                 message.success("Referral code copied to clipboard!");
//             } else {
//                 const textArea = document.createElement("textarea");
//                 textArea.value = code;
//                 textArea.style.position = "fixed";
//                 textArea.style.left = "-999999px";
//                 textArea.style.top = "-999999px";
//                 document.body.appendChild(textArea);
//                 textArea.focus();
//                 textArea.select();

//                 try {
//                     const successful = document.execCommand('copy');
//                     if (successful) {
//                         message.success("Referral code copied to clipboard!");
//                     } else {
//                         message.error("Failed to copy code");
//                     }
//                 } catch (err) {
//                     console.error('Fallback copy failed:', err);
//                     message.error("Failed to copy code");
//                 }

//                 document.body.removeChild(textArea);
//             }
//         } catch (error) {
//             console.error("Error copying to clipboard:", error);
//             message.error("Failed to copy code. Please copy manually.");
//         }
//     };

//     const handleWhatsAppShare = (referral) => {
//         const message = `🎉 *Khasdar Mahotsav Registration*\n\n📍 Event: ${referral.eventName}\n🚪 Gate: ${referral.gateNumber}\n\n🔗 Register here:\n${referral.referralLink}\n\n✅ Use Referral Code: *${referral.referralCode}*`;
//         const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
//         window.open(whatsappUrl, '_blank');
//     };

//     const handleShare = async (referral) => {
//         const shareData = {
//             title: 'Khasdar Mahotsav Registration',
//             text: `Register for ${referral.eventName} at Gate ${referral.gateNumber}`,
//             url: referral.referralLink
//         };

//         try {
//             if (navigator.share) {
//                 await navigator.share(shareData);
//                 message.success('Shared successfully!');
//             } else {
//                 handleCopyLink(referral.referralLink);
//             }
//         } catch (err) {
//             if (err.name !== 'AbortError') {
//                 handleCopyLink(referral.referralLink);
//             }
//         }
//     };

//     const handleSearch = (value) => {
//         setSearchText(value);
//         if (!value) {
//             setFilteredData(referralCodes);
//             return;
//         }

//         const searchValue = value.toLowerCase();
//         const filtered = referralCodes.filter((item) => {
//             return (
//                 item?.referralCode?.toLowerCase().includes(searchValue) ||
//                 item?.eventName?.toLowerCase().includes(searchValue) ||
//                 item?.gateNumber?.toString().includes(searchValue)
//             );
//         });
//         setFilteredData(filtered);
//     };

//     const handleReset = () => {
//         setSearchText("");
//         setFilteredData(referralCodes);
//     };

//     const downloadQRCode = (referralCode) => {
//         const canvas = document.getElementById(`qr-${referralCode}`);
//         if (canvas) {
//             const url = canvas.toDataURL("image/png");
//             const link = document.createElement("a");
//             link.download = `${referralCode}-QR.png`;
//             link.href = url;
//             link.click();
//             message.success('QR Code downloaded successfully!');
//         }
//     };

//     // Fixed view details handler
//     const handleViewDetails = (record) => {
//         console.log("Viewing details for:", record);

//         // Ensure we have all necessary data
//         const completeReferral = {
//             ...record,
//             eventName: record.eventName || 'Unknown Event',
//             referralLink: record.referralLink || '',
//             referralCode: record.referralCode || '',
//             gateNumber: record.gateNumber || 0,
//             usageCount: record.usageCount || 0,
//             createdAt: record.createdAt || new Date().toISOString(),
//             maxUses: record.maxUses || null,
//             expiryDate: record.expiryDate || null
//         };

//         setSelectedReferral(completeReferral);
//         setDetailsModalOpen(true);
//     };

//     const columns = [
//         {
//             title: "Sr.No.",
//             dataIndex: "id",
//             key: "id",
//             width: 70,
//             sorter: (a, b) => a.id - b.id,
//         },
//         {
//             title: "Referral Code",
//             dataIndex: "referralCode",
//             key: "referralCode",
//             width: 220,
//             render: (code, record) => (
//                 <Button
//                     type="link"
//                     onClick={() => handleViewDetails(record)}
//                     style={{ padding: 0, height: 'auto' }}
//                 >
//                     {code}
//                 </Button>
//             ),
//         },
//         {
//             title: "Event",
//             dataIndex: "eventName",
//             key: "eventName",
//             width: 200,
//         },
//         {
//             title: "Gate",
//             dataIndex: "gateNumber",
//             key: "gateNumber",
//             width: 80,
//             align: "center",
//             render: (gate) => <Tag color="blue">Gate {gate}</Tag>,
//         },
//         {
//             title: "Usage",
//             dataIndex: "usageCount",
//             key: "usageCount",
//             width: 100,
//             align: "center",
//             render: (count, record) => (
//                 <Tag color={count > 0 ? "green" : "default"}>
//                     {count} {record.maxUses ? `/ ${record.maxUses}` : ''}
//                 </Tag>
//             ),
//         },
//         {
//             title: "Status",
//             dataIndex: "status",
//             key: "status",
//             width: 120,
//             align: "center",
//             render: (status, record) => {
//                 let color = "green";
//                 let text = "Active";

//                 if (record.expiryDate && new Date(record.expiryDate) < new Date()) {
//                     color = "red";
//                     text = "Expired";
//                 } else if (record.maxUses && record.usageCount >= record.maxUses) {
//                     color = "orange";
//                     text = "Limit Reached";
//                 }

//                 return <Tag color={color}>{text}</Tag>;
//             },
//         },
//         {
//             title: "Created",
//             dataIndex: "createdAt",
//             key: "createdAt",
//             width: 150,
//             render: (date) => new Date(date).toLocaleDateString(),
//         },
//         {
//             title: "Actions",
//             key: "actions",
//             width: 150,
//             align: "center",
//             fixed: 'right',
//             render: (_, record) => (
//                 <Space>
//                     <Tooltip title="WhatsApp Share">
//                         <Button
//                             type="text"
//                             size="small"
//                             icon={<WhatsAppOutlined style={{ color: '#25D366' }} />}
//                             onClick={() => handleWhatsAppShare(record)}
//                         />
//                     </Tooltip>
//                     <Tooltip title="Copy Link">
//                         <Button
//                             type="text"
//                             size="small"
//                             icon={<LinkOutlined />}
//                             onClick={() => handleCopyLink(record.referralLink)}
//                         />
//                     </Tooltip>
//                     <Tooltip title="View Details">
//                         <Button
//                             type="text"
//                             size="small"
//                             icon={<QrcodeOutlined />}
//                             onClick={() => handleViewDetails(record)}
//                         />
//                     </Tooltip>
//                 </Space>
//             ),
//         },
//     ];

//     const rows = filteredData.map((item, index) => ({
//         key: item._id || index,
//         id: index + 1,
//         ...item,
//     }));

//     const statistics = {
//         totalCodes: referralCodes.length,
//         activeCodes: referralCodes.filter(r =>
//             (!r.expiryDate || new Date(r.expiryDate) >= new Date()) &&
//             (!r.maxUses || r.usageCount < r.maxUses)
//         ).length,
//         totalUsage: referralCodes.reduce((sum, r) => sum + (r.usageCount || 0), 0),
//     };

//     return (
//         <AdminLayout>
//             <div style={{ padding: "24px", background: "#f0f2f5", minHeight: "100vh" }}>
//                 <div style={{ marginBottom: 24 }}>
//                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: '12px' }}>
//                         <Title level={3} style={{ margin: 0 }}>Referral Code Management</Title>
//                         <Button
//                             type="primary"
//                             icon={<PlusOutlined />}
//                             onClick={() => setCreateModalOpen(true)}
//                             size="large"
//                         >
//                             Create Referral Code
//                         </Button>
//                     </div>

//                     <Row gutter={[16, 16]}>
//                         <Col xs={24} sm={8}>
//                             <Card>
//                                 <Statistic
//                                     title="Total Referral Codes"
//                                     value={statistics.totalCodes}
//                                     prefix={<LinkOutlined />}
//                                     valueStyle={{ color: '#1890ff' }}
//                                 />
//                             </Card>
//                         </Col>
//                         <Col xs={24} sm={8}>
//                             <Card>
//                                 <Statistic
//                                     title="Active Codes"
//                                     value={statistics.activeCodes}
//                                     prefix={<CalendarOutlined />}
//                                     valueStyle={{ color: '#52c41a' }}
//                                 />
//                             </Card>
//                         </Col>
//                         <Col xs={24} sm={8}>
//                             <Card>
//                                 <Statistic
//                                     title="Total Usage"
//                                     value={statistics.totalUsage}
//                                     prefix={<TeamOutlined />}
//                                     valueStyle={{ color: '#722ed1' }}
//                                 />
//                             </Card>
//                         </Col>
//                     </Row>
//                 </div>

//                 <div style={{ background: "#fff", padding: "24px", borderRadius: "8px" }}>
//                     <Space style={{ marginBottom: 16, width: "100%", justifyContent: "space-between", flexWrap: "wrap" }}>
//                         <Space wrap>
//                             <Input
//                                 placeholder="Search by code, event, or gate"
//                                 prefix={<SearchOutlined />}
//                                 value={searchText}
//                                 onChange={(e) => handleSearch(e.target.value)}
//                                 style={{ width: 320 }}
//                                 allowClear
//                             />
//                             <Button icon={<ReloadOutlined />} onClick={handleReset}>
//                                 Reset
//                             </Button>
//                         </Space>
//                         <Text type="secondary">
//                             Showing {rows.length} of {referralCodes.length} records
//                         </Text>
//                     </Space>

//                     <Table
//                         columns={columns}
//                         dataSource={rows}
//                         loading={loading}
//                         pagination={{
//                             defaultPageSize: 50,
//                             showSizeChanger: true,
//                             showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
//                             pageSizeOptions: ["25", "50", "100", "200"],
//                         }}
//                         bordered
//                         size="middle"
//                         scroll={{ x: 1200 }}
//                     />
//                 </div>

//                 {/* Create Referral Modal */}
//                 <Modal
//                     title="Create New Referral Code"
//                     open={createModalOpen}
//                     onCancel={() => {
//                         setCreateModalOpen(false);
//                         form.resetFields();
//                     }}
//                     footer={null}
//                     width={600}
//                 >
//                     <Form
//                         form={form}
//                         layout="vertical"
//                         onFinish={handleCreateReferral}
//                     >
//                         <Form.Item
//                             label="Select Event"
//                             name="eventId"
//                             rules={[{ required: true, message: "Please select an event" }]}
//                         >
//                             <Select
//                                 placeholder="Choose an event"
//                                 showSearch
//                                 optionFilterProp="children"
//                             >
//                                 {events.map((event) => (
//                                     <Option key={event._id} value={event._id}>
//                                         {event.eventName} - {new Date(event.eventDate).toLocaleDateString()}
//                                     </Option>
//                                 ))}
//                             </Select>
//                         </Form.Item>

//                         {/* <Form.Item
//                             label="Gate Number"
//                             name="gateNumber"
//                             rules={[
//                                 { required: true, message: "Please enter gate number" },
//                                 { pattern: /^[1-9]\d*$/, message: "Please enter a valid gate number" }
//                             ]}
//                         >
//                             <Input
//                                 placeholder="Enter gate number (e.g., 1, 2, 3)"
//                                 type="number"
//                                 min={1}
//                             />
//                         </Form.Item>

//                         <Form.Item
//                             label="Maximum Uses (Optional)"
//                             name="maxUses"
//                             tooltip="Leave empty for unlimited uses"
//                         >
//                             <Input
//                                 placeholder="Enter maximum number of uses"
//                                 type="number"
//                                 min={1}
//                             />
//                         </Form.Item>

//                         <Form.Item
//                             label="Expiry Date (Optional)"
//                             name="expiryDate"
//                             tooltip="Leave empty for no expiry"
//                         >
//                             <Input type="date" />
//                         </Form.Item> */}

//                         <Form.Item>
//                             <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
//                                 <Button onClick={() => {
//                                     setCreateModalOpen(false);
//                                     form.resetFields();
//                                 }}>
//                                     Cancel
//                                 </Button>
//                                 <Button type="primary" htmlType="submit">
//                                     Generate Referral Code
//                                 </Button>
//                             </Space>
//                         </Form.Item>
//                     </Form>
//                 </Modal>

//                 {/* Details Modal */}
//                 <Modal
//                     title={<Title level={4} style={{ margin: 0 }}>Referral Code Details</Title>}
//                     open={detailsModalOpen}
//                     onCancel={() => setDetailsModalOpen(false)}
//                     width={750}
//                     footer={[
//                         <Button key="close" onClick={() => setDetailsModalOpen(false)}>
//                             Close
//                         </Button>,
//                     ]}
//                 >
//                     {selectedReferral && (
//                         <div>
//                             <Card style={{ marginBottom: 16, background: '#f9f9f9' }}>
//                                 <Row gutter={[24, 16]}>
//                                     <Col xs={24} md={10}>
//                                         <div style={{ textAlign: 'center' }}>
//                                             <div style={{
//                                                 background: 'white',
//                                                 padding: '20px',
//                                                 borderRadius: '12px',
//                                                 boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                                             }}>
//                                                 <QRCodeCanvas
//                                                     id={`qr-${selectedReferral.referralCode}`}
//                                                     value={selectedReferral.referralLink}
//                                                     size={180}
//                                                     level="H"
//                                                     includeMargin={true}
//                                                 />
//                                             </div>
//                                             <Space direction="vertical" style={{ width: '100%', marginTop: 16 }} size="small">
//                                                 <Button
//                                                     type="primary"
//                                                     icon={<DownloadOutlined />}
//                                                     onClick={() => downloadQRCode(selectedReferral.referralCode)}
//                                                     block
//                                                 >
//                                                     Download QR Code
//                                                 </Button>
//                                             </Space>
//                                         </div>
//                                     </Col>
//                                     <Col xs={24} md={14}>
//                                         <Space direction="vertical" style={{ width: '100%' }} size="middle">
//                                             <div>
//                                                 <Text strong style={{ fontSize: 13 }}>Referral Code:</Text>
//                                                 <div style={{ marginTop: 4 }}>
//                                                     <Input
//                                                         value={selectedReferral.referralCode}
//                                                         readOnly
//                                                         size="large"
//                                                         style={{ fontWeight: 600, fontSize: 14 }}
//                                                         addonAfter={
//                                                             <CopyOutlined
//                                                                 onClick={() => handleCopyCode(selectedReferral.referralCode)}
//                                                                 style={{ cursor: 'pointer' }}
//                                                             />
//                                                         }
//                                                     />
//                                                 </div>
//                                             </div>

//                                             <div>
//                                                 <Text strong style={{ fontSize: 13 }}>Share Options:</Text>
//                                                 <div style={{ marginTop: 8 }}>
//                                                     <Space wrap>
//                                                         <Button
//                                                             type="primary"
//                                                             icon={<WhatsAppOutlined />}
//                                                             onClick={() => handleWhatsAppShare(selectedReferral)}
//                                                             style={{ background: '#25D366', borderColor: '#25D366' }}
//                                                         >
//                                                             Share on WhatsApp
//                                                         </Button>
//                                                         <Button
//                                                             icon={<ShareAltOutlined />}
//                                                             onClick={() => handleShare(selectedReferral)}
//                                                         >
//                                                             Share
//                                                         </Button>
//                                                         <Button
//                                                             icon={<CopyOutlined />}
//                                                             onClick={() => handleCopyLink(selectedReferral.referralLink)}
//                                                         >
//                                                             Copy Link
//                                                         </Button>
//                                                     </Space>
//                                                 </div>
//                                             </div>
//                                         </Space>
//                                     </Col>
//                                 </Row>
//                             </Card>

//                             <Divider style={{ margin: '16px 0' }} />

//                             <Space direction="vertical" style={{ width: '100%' }} size="middle">
//                                 <div>
//                                     <Text strong>Referral Link:</Text>
//                                     <div style={{ marginTop: 4 }}>
//                                         <Input.TextArea
//                                             value={selectedReferral.referralLink}
//                                             readOnly
//                                             rows={2}
//                                             style={{ fontSize: 13 }}
//                                         />
//                                     </div>
//                                 </div>

//                                 <Row gutter={16}>
//                                     <Col span={12}>
//                                         <Card size="small" style={{ background: '#fafafa' }}>
//                                             <Text type="secondary" style={{ fontSize: 12 }}>Event</Text>
//                                             <div><Text strong>{selectedReferral.eventName}</Text></div>
//                                         </Card>
//                                     </Col>
//                                     <Col span={12}>
//                                         <Card size="small" style={{ background: '#fafafa' }}>
//                                             <Text type="secondary" style={{ fontSize: 12 }}>Gate Number</Text>
//                                             <div><Tag color="blue">Gate {selectedReferral.gateNumber}</Tag></div>
//                                         </Card>
//                                     </Col>
//                                 </Row>

//                                 <Row gutter={16}>
//                                     <Col span={12}>
//                                         <Card size="small" style={{ background: '#fafafa' }}>
//                                             <Text type="secondary" style={{ fontSize: 12 }}>Usage Count</Text>
//                                             <div>
//                                                 <Text strong>
//                                                     {selectedReferral.usageCount || 0}
//                                                     {selectedReferral.maxUses && <Text type="secondary"> / {selectedReferral.maxUses}</Text>}
//                                                 </Text>
//                                             </div>
//                                         </Card>
//                                     </Col>
//                                     <Col span={12}>
//                                         <Card size="small" style={{ background: '#fafafa' }}>
//                                             <Text type="secondary" style={{ fontSize: 12 }}>Created</Text>
//                                             <div><Text strong>{new Date(selectedReferral.createdAt).toLocaleDateString()}</Text></div>
//                                         </Card>
//                                     </Col>
//                                 </Row>

//                                 {selectedReferral.expiryDate && (
//                                     <Card size="small" style={{ background: '#fff7e6', borderColor: '#ffa940' }}>
//                                         <Text type="secondary" style={{ fontSize: 12 }}>Expires On</Text>
//                                         <div><Text strong>{new Date(selectedReferral.expiryDate).toLocaleDateString()}</Text></div>
//                                     </Card>
//                                 )}
//                             </Space>
//                         </div>
//                     )}
//                 </Modal>
//             </div>
//         </AdminLayout>
//     );
// };

// export default ReferralCodeManagement;
import React, { useEffect, useState } from "react";
import {
    Table, Button, Input, Space, Tag, Modal, Typography, message,
    Form, Select, Card, Row, Col, Statistic, Tooltip, Divider, Drawer
} from "antd";
import {
    SearchOutlined, ReloadOutlined, PlusOutlined, CopyOutlined,
    QrcodeOutlined, LinkOutlined, CalendarOutlined, TeamOutlined,
    DownloadOutlined, WhatsAppOutlined, ShareAltOutlined, EyeOutlined
} from "@ant-design/icons";
import { QRCodeCanvas } from "qrcode.react";
import AdminLayout from "./Drawer";

const { Text, Title } = Typography;
const { Option } = Select;

const ReferralCodeManagement = () => {
    const [loading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const [referralCodes, setReferralCodes] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [detailsModalOpen, setDetailsModalOpen] = useState(false);
    const [selectedReferral, setSelectedReferral] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [selectedEventId, setSelectedEventId] = useState(null);
    const [form] = Form.useForm();

    useEffect(() => {
        fetchEvents();
        fetchReferralCodes();
        
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setFilteredData(referralCodes);
    }, [referralCodes]);

    const fetchEvents = async () => {
        try {
            const response = await fetch("/api/get/events", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            if (data.status === "success") {
                setEvents(data.data);
            }
        } catch (error) {
            console.error("Fetch error:", error.message);
            message.error("Failed to fetch events");
        }
    };

    const fetchReferralCodes = async () => {
        setLoading(true);
        try {
            const response = await fetch("/api/referral/get-all", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            if (data.status === "success") {
                setReferralCodes(data.data);
            }
        } catch (error) {
            console.error("Error fetching referral codes:", error);
            message.error("Failed to fetch referral codes");
        } finally {
            setLoading(false);
        }
    };

    const handleCopyLink = async (link) => {
        try {
            if (!link) {
                message.error("No link available to copy");
                return;
            }

            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(link);
                message.success("Referral link copied!");
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = link;
                textArea.style.position = "fixed";
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    const successful = document.execCommand('copy');
                    if (successful) {
                        message.success("Referral link copied!");
                    } else {
                        message.error("Failed to copy link");
                    }
                } catch (err) {
                    message.error("Failed to copy link");
                }

                document.body.removeChild(textArea);
            }
        } catch (error) {
            message.error("Failed to copy link");
        }
    };

    const handleCopyCode = async (code) => {
        try {
            if (!code) {
                message.error("No code available to copy");
                return;
            }

            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(code);
                message.success("Referral code copied!");
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = code;
                textArea.style.position = "fixed";
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    const successful = document.execCommand('copy');
                    if (successful) {
                        message.success("Referral code copied!");
                    } else {
                        message.error("Failed to copy code");
                    }
                } catch (err) {
                    message.error("Failed to copy code");
                }

                document.body.removeChild(textArea);
            }
        } catch (error) {
            message.error("Failed to copy code");
        }
    };

    const handleWhatsAppShare = (referral) => {
        const msg = `🎉 *Event Registration*\n\n📍 Event: ${referral.eventName}\n🚪 Gate: ${referral.gateNumber}\n\n🔗 Register here:\n${referral.referralLink}\n\n✅ Use Code: *${referral.referralCode}*`;
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(msg)}`;
        window.open(whatsappUrl, '_blank');
    };

    const handleShare = async (referral) => {
        const shareData = {
            title: 'Event Registration',
            text: `Register for ${referral.eventName} at Gate ${referral.gateNumber}`,
            url: referral.referralLink
        };

        try {
            if (navigator.share) {
                await navigator.share(shareData);
                message.success('Shared successfully!');
            } else {
                handleCopyLink(referral.referralLink);
            }
        } catch (err) {
            if (err.name !== 'AbortError') {
                handleCopyLink(referral.referralLink);
            }
        }
    };

    const handleSearch = (value) => {
        setSearchText(value);
        if (!value) {
            setFilteredData(referralCodes);
            return;
        }

        const searchValue = value.toLowerCase();
        const filtered = referralCodes.filter((item) => {
            return (
                item?.referralCode?.toLowerCase().includes(searchValue) ||
                item?.eventName?.toLowerCase().includes(searchValue) ||
                item?.gateNumber?.toString().includes(searchValue)
            );
        });
        setFilteredData(filtered);
    };

    const handleReset = () => {
        setSearchText("");
        setFilteredData(referralCodes);
    };

    const downloadQRCode = (referralCode) => {
        const canvas = document.getElementById(`qr-${referralCode}`);
        if (canvas) {
            const url = canvas.toDataURL("image/png");
            const link = document.createElement("a");
            link.download = `${referralCode}-QR.png`;
            link.href = url;
            link.click();
            message.success('QR Code downloaded!');
        }
    };

    const handleViewDetails = (record) => {
        setSelectedReferral(record);
        setDetailsModalOpen(true);
    };

    const generateReferralCode = () => {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
        let code = 'R';
        for (let i = 0; i < 5; i++) {
            code += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return code;
    };

    const generateHexaCode = () => {
        const chars = '0123456789ABCDEF';
        let hexaCode = 'R';
        for (let i = 0; i < 7; i++) {
            hexaCode += chars[Math.floor(Math.random() * chars.length)];
        }
        return hexaCode;
    };

    const handleCreateReferral = async () => {
        try {
            if (!selectedEventId) {
                message.error("Please select an event");
                return;
            }

            const selectedEvent = events.find(e => e._id === selectedEventId);
            if (!selectedEvent) {
                message.error("Event not found");
                return;
            }

            const referralCode = generateReferralCode();
            const hexaCode = generateHexaCode();
            const referralLink = `${window.location.origin}/registration/2025/${hexaCode}`;

            const payload = {
                eventId: selectedEventId,
                gateNumber: 1,
                referralCode: referralCode,
                hexaCode: hexaCode,
                referralLink: referralLink,
                createdBy: "Admin",
                maxUses: null,
                expiryDate: null,
            };

            const response = await fetch("/api/referral/create", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.ok) {
                message.success("Referral code created successfully!");
                setSelectedEventId(null);
                setCreateModalOpen(false);
                fetchReferralCodes();

                // Show the created referral details
                setSelectedReferral({
                    ...payload,
                    _id: data.data._id,
                    usageCount: 0,
                    createdAt: new Date().toISOString(),
                    eventName: selectedEvent.eventName,
                });
                setDetailsModalOpen(true);
            } else {
                message.error(data.message || "Failed to create referral code");
            }
        } catch (error) {
            console.error("Error creating referral:", error);
            message.error("An error occurred while creating referral code");
        }
    };

    const statistics = {
        totalCodes: referralCodes.length,
        activeCodes: referralCodes.filter(r =>
            (!r.expiryDate || new Date(r.expiryDate) >= new Date()) &&
            (!r.maxUses || r.usageCount < r.maxUses)
        ).length,
        totalUsage: referralCodes.reduce((sum, r) => sum + (r.usageCount || 0), 0),
    };

    // Mobile Card View
    const MobileReferralCard = ({ item, index }) => (
        <Card 
            size="small" 
            style={{ 
                marginBottom: 12,
                borderRadius: 8,
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                <div style={{ flex: 1 }}>
                    <Text strong style={{ fontSize: 15, display: 'block', marginBottom: 4 }}>
                        {item.referralCode}
                    </Text>
                    <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>
                        {item.eventName}
                    </Text>
                    <Space size={4}>
                        <Tag color="blue" style={{ fontSize: 11, margin: 0 }}>Gate {item.gateNumber}</Tag>
                        <Tag color={item.usageCount > 0 ? "green" : "default"} style={{ fontSize: 11, margin: 0 }}>
                            {item.usageCount} {item.maxUses ? `/ ${item.maxUses}` : ''} uses
                        </Tag>
                    </Space>
                </div>
                <Button 
                    type="text" 
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={() => handleViewDetails(item)}
                />
            </div>
            <Divider style={{ margin: '8px 0' }} />
            <Space size={4} wrap>
                <Button
                    type="text"
                    size="small"
                    icon={<WhatsAppOutlined style={{ color: '#25D366' }} />}
                    onClick={() => handleWhatsAppShare(item)}
                >
                    Share
                </Button>
                <Button
                    type="text"
                    size="small"
                    icon={<CopyOutlined />}
                    onClick={() => handleCopyCode(item.referralCode)}
                >
                    Copy
                </Button>
                <Button
                    type="text"
                    size="small"
                    icon={<LinkOutlined />}
                    onClick={() => handleCopyLink(item.referralLink)}
                >
                    Link
                </Button>
            </Space>
        </Card>
    );

    // Desktop Table Columns
    const columns = [
        {
            title: "Sr.No.",
            dataIndex: "id",
            key: "id",
            width: 70,
            sorter: (a, b) => a.id - b.id,
        },
        {
            title: "Referral Code",
            dataIndex: "referralCode",
            key: "referralCode",
            width: 150,
            render: (code, record) => (
                <Button
                    type="link"
                    onClick={() => handleViewDetails(record)}
                    style={{ padding: 0, height: 'auto' }}
                >
                    {code}
                </Button>
            ),
        },
        {
            title: "Event",
            dataIndex: "eventName",
            key: "eventName",
            width: 200,
        },
        {
            title: "Gate",
            dataIndex: "gateNumber",
            key: "gateNumber",
            width: 80,
            align: "center",
            render: (gate) => <Tag color="blue">Gate {gate}</Tag>,
        },
        {
            title: "Usage",
            dataIndex: "usageCount",
            key: "usageCount",
            width: 100,
            align: "center",
            render: (count, record) => (
                <Tag color={count > 0 ? "green" : "default"}>
                    {count} {record.maxUses ? `/ ${record.maxUses}` : ''}
                </Tag>
            ),
        },
        {
            title: "Status",
            key: "status",
            width: 100,
            align: "center",
            render: (_, record) => {
                let color = "green";
                let text = "Active";

                if (record.expiryDate && new Date(record.expiryDate) < new Date()) {
                    color = "red";
                    text = "Expired";
                } else if (record.maxUses && record.usageCount >= record.maxUses) {
                    color = "orange";
                    text = "Limit";
                }

                return <Tag color={color}>{text}</Tag>;
            },
        },
        {
            title: "Actions",
            key: "actions",
            width: 140,
            align: "center",
            fixed: 'right',
            render: (_, record) => (
                <Space size={4}>
                    <Tooltip title="WhatsApp">
                        <Button
                            type="text"
                            size="small"
                            icon={<WhatsAppOutlined style={{ color: '#25D366' }} />}
                            onClick={() => handleWhatsAppShare(record)}
                        />
                    </Tooltip>
                    <Tooltip title="Copy Link">
                        <Button
                            type="text"
                            size="small"
                            icon={<LinkOutlined />}
                            onClick={() => handleCopyLink(record.referralLink)}
                        />
                    </Tooltip>
                    <Tooltip title="Details">
                        <Button
                            type="text"
                            size="small"
                            icon={<QrcodeOutlined />}
                            onClick={() => handleViewDetails(record)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    const rows = filteredData.map((item, index) => ({
        key: item._id || index,
        id: index + 1,
        ...item,
    }));

    return (
        <AdminLayout>
        <div style={{ 
            padding: isMobile ? "12px" : "24px", 
            background: "#f0f2f5", 
            minHeight: "100vh" 
        }}>
            {/* Header */}
            <div style={{ marginBottom: isMobile ? 12 : 20 }}>
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: isMobile ? 12 : 16,
                    gap: 8
                }}>
                    <Title level={isMobile ? 4 : 3} style={{ margin: 0, fontSize: isMobile ? 18 : 24 }}>
                        Referral Codes
                    </Title>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => setCreateModalOpen(true)}
                        size={isMobile ? "middle" : "large"}
                    >
                        {isMobile ? "Create" : "Create Code"}
                    </Button>
                </div>

                {/* Statistics */}
                <Row gutter={[8, 8]}>
                    <Col xs={8} sm={8} md={8}>
                        <Card size="small" bodyStyle={{ padding: isMobile ? '12px' : '16px' }}>
                            <Statistic
                                title={<span style={{ fontSize: isMobile ? 11 : 14 }}>Total</span>}
                                value={statistics.totalCodes}
                                prefix={<LinkOutlined style={{ fontSize: isMobile ? 16 : 20 }} />}
                                valueStyle={{ color: '#1890ff', fontSize: isMobile ? 18 : 24 }}
                            />
                        </Card>
                    </Col>
                    <Col xs={8} sm={8} md={8}>
                        <Card size="small" bodyStyle={{ padding: isMobile ? '12px' : '16px' }}>
                            <Statistic
                                title={<span style={{ fontSize: isMobile ? 11 : 14 }}>Active</span>}
                                value={statistics.activeCodes}
                                prefix={<CalendarOutlined style={{ fontSize: isMobile ? 16 : 20 }} />}
                                valueStyle={{ color: '#52c41a', fontSize: isMobile ? 18 : 24 }}
                            />
                        </Card>
                    </Col>
                    <Col xs={8} sm={8} md={8}>
                        <Card size="small" bodyStyle={{ padding: isMobile ? '12px' : '16px' }}>
                            <Statistic
                                title={<span style={{ fontSize: isMobile ? 11 : 14 }}>Usage</span>}
                                value={statistics.totalUsage}
                                prefix={<TeamOutlined style={{ fontSize: isMobile ? 16 : 20 }} />}
                                valueStyle={{ color: '#722ed1', fontSize: isMobile ? 18 : 24 }}
                            />
                        </Card>
                    </Col>
                </Row>
            </div>

            {/* Search & Content */}
            <div style={{ background: "#fff", padding: isMobile ? "12px" : "20px", borderRadius: "8px" }}>
                <Space style={{ 
                    marginBottom: 12, 
                    width: "100%", 
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 8
                }}>
                    <Space wrap size={8}>
                        <Input
                            placeholder={isMobile ? "Search..." : "Search by code, event, or gate"}
                            prefix={<SearchOutlined />}
                            value={searchText}
                            onChange={(e) => handleSearch(e.target.value)}
                            style={{ width: isMobile ? 200 : 280 }}
                            allowClear
                            size={isMobile ? "middle" : "large"}
                        />
                        <Button 
                            icon={<ReloadOutlined />} 
                            onClick={handleReset}
                            size={isMobile ? "middle" : "large"}
                        >
                            {!isMobile && "Reset"}
                        </Button>
                    </Space>
                    <Text type="secondary" style={{ fontSize: isMobile ? 11 : 14 }}>
                        {rows.length} of {referralCodes.length}
                    </Text>
                </Space>

                {/* Mobile: Card View, Desktop: Table */}
                {isMobile ? (
                    <div>
                        {rows.map((item, index) => (
                            <MobileReferralCard key={item.key} item={item} index={index} />
                        ))}
                    </div>
                ) : (
                    <Table
                        columns={columns}
                        dataSource={rows}
                        loading={loading}
                        pagination={{
                            defaultPageSize: 25,
                            showSizeChanger: true,
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                            pageSizeOptions: ["25", "50", "100"],
                            size: "small"
                        }}
                        bordered
                        size="small"
                        scroll={{ x: 900 }}
                    />
                )}
            </div>

            {/* Create Modal */}
            <Modal
                title={<Text strong style={{ fontSize: isMobile ? 16 : 18 }}>Create Referral Code</Text>}
                open={createModalOpen}
                onCancel={() => {
                    setCreateModalOpen(false);
                    setSelectedEventId(null);
                }}
                centered
                width={isMobile ? '90%' : 500}
                footer={[
                    <Button key="cancel" onClick={() => {
                        setCreateModalOpen(false);
                        setSelectedEventId(null);
                    }}>
                        Cancel
                    </Button>,
                    <Button 
                        key="submit" 
                        type="primary" 
                        onClick={handleCreateReferral}
                        disabled={!selectedEventId}
                    >
                        Generate Code
                    </Button>
                ]}
            >
                <div style={{ marginTop: 16, marginBottom: 8 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Select Event <Text type="danger">*</Text></Text>
                    <Select
                        placeholder="Choose an event"
                        showSearch
                        optionFilterProp="children"
                        style={{ width: '100%' }}
                        value={selectedEventId}
                        onChange={(value) => setSelectedEventId(value)}
                        size="large"
                    >
                        {events.map((event) => (
                            <Option key={event._id} value={event._id}>
                                {event.eventName} - {new Date(event.eventDate).toLocaleDateString()}
                            </Option>
                        ))}
                    </Select>
                </div>
            </Modal>

            {/* Details Modal */}
            <Modal
                title={<Title level={isMobile ? 5 : 4} style={{ margin: 0 }}>Referral Details</Title>}
                open={detailsModalOpen}
                onCancel={() => setDetailsModalOpen(false)}
                centered
                width={isMobile ? '90%' : 700}
                footer={[
                    <Button key="close" type="primary" onClick={() => setDetailsModalOpen(false)}>
                        Close
                    </Button>,
                ]}
            >
                {selectedReferral && (
                    <div>
                        <Card size="small" style={{ marginBottom: 12, background: '#f9f9f9' }}>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} md={10}>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{
                                            background: 'white',
                                            padding: isMobile ? '12px' : '20px',
                                            borderRadius: '12px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            display: 'inline-block'
                                        }}>
                                            <QRCodeCanvas
                                                id={`qr-${selectedReferral.referralCode}`}
                                                value={selectedReferral.referralLink}
                                                size={isMobile ? 140 : 180}
                                                level="H"
                                                includeMargin={true}
                                            />
                                        </div>
                                        <Button
                                            type="primary"
                                            icon={<DownloadOutlined />}
                                            onClick={() => downloadQRCode(selectedReferral.referralCode)}
                                            block
                                            size="small"
                                            style={{ marginTop: 12 }}
                                        >
                                            Download QR
                                        </Button>
                                    </div>
                                </Col>
                                <Col xs={24} md={14}>
                                    <Space direction="vertical" style={{ width: '100%' }} size="small">
                                        <div>
                                            <Text strong style={{ fontSize: 12 }}>Referral Code:</Text>
                                            <Input
                                                value={selectedReferral.referralCode}
                                                readOnly
                                                size="small"
                                                style={{ fontWeight: 600, fontSize: 13, marginTop: 4 }}
                                                addonAfter={
                                                    <CopyOutlined
                                                        onClick={() => handleCopyCode(selectedReferral.referralCode)}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                }
                                            />
                                        </div>

                                        <div>
                                            <Text strong style={{ fontSize: 12 }}>Share:</Text>
                                            <Space wrap size={4} style={{ marginTop: 4 }}>
                                                <Button
                                                    type="primary"
                                                    size="small"
                                                    icon={<WhatsAppOutlined />}
                                                    onClick={() => handleWhatsAppShare(selectedReferral)}
                                                    style={{ background: '#25D366', borderColor: '#25D366' }}
                                                >
                                                    WhatsApp
                                                </Button>
                                                <Button
                                                    size="small"
                                                    icon={<ShareAltOutlined />}
                                                    onClick={() => handleShare(selectedReferral)}
                                                >
                                                    Share
                                                </Button>
                                                <Button
                                                    size="small"
                                                    icon={<CopyOutlined />}
                                                    onClick={() => handleCopyLink(selectedReferral.referralLink)}
                                                >
                                                    Copy Link
                                                </Button>
                                            </Space>
                                        </div>
                                    </Space>
                                </Col>
                            </Row>
                        </Card>

                        <Divider style={{ margin: '12px 0' }} />

                        <Space direction="vertical" style={{ width: '100%' }} size="small">
                            <div>
                                <Text strong style={{ fontSize: 12 }}>Referral Link:</Text>
                                <Input.TextArea
                                    value={selectedReferral.referralLink}
                                    readOnly
                                    rows={2}
                                    size="small"
                                    style={{ fontSize: 11, marginTop: 4 }}
                                />
                            </div>

                            <Row gutter={8}>
                                <Col span={12}>
                                    <Card size="small" bodyStyle={{ padding: 8 }} style={{ background: '#fafafa' }}>
                                        <Text type="secondary" style={{ fontSize: 11 }}>Event</Text>
                                        <div><Text strong style={{ fontSize: 12 }}>{selectedReferral.eventName}</Text></div>
                                    </Card>
                                </Col>
                                <Col span={12}>
                                    <Card size="small" bodyStyle={{ padding: 8 }} style={{ background: '#fafafa' }}>
                                        <Text type="secondary" style={{ fontSize: 11 }}>Gate</Text>
                                        <div><Tag color="blue" style={{ fontSize: 11 }}>Gate {selectedReferral.gateNumber}</Tag></div>
                                    </Card>
                                </Col>
                            </Row>

                            <Row gutter={8}>
                                <Col span={12}>
                                    <Card size="small" bodyStyle={{ padding: 8 }} style={{ background: '#fafafa' }}>
                                        <Text type="secondary" style={{ fontSize: 11 }}>Usage</Text>
                                        <div>
                                            <Text strong style={{ fontSize: 12 }}>
                                                {selectedReferral.usageCount || 0}
                                                {selectedReferral.maxUses && <Text type="secondary"> / {selectedReferral.maxUses}</Text>}
                                            </Text>
                                        </div>
                                    </Card>
                                </Col>
                                <Col span={12}>
                                    <Card size="small" bodyStyle={{ padding: 8 }} style={{ background: '#fafafa' }}>
                                        <Text type="secondary" style={{ fontSize: 11 }}>Created</Text>
                                        <div><Text strong style={{ fontSize: 12 }}>{new Date(selectedReferral.createdAt).toLocaleDateString()}</Text></div>
                                    </Card>
                                </Col>
                            </Row>
                        </Space>
                    </div>
                )}
            </Modal>
        </div>
        </AdminLayout>
    );
};

export default ReferralCodeManagement;